module.exports = __webpack_public_path__ + "media/1.8ec237b0.mp3";